import styled from 'styled-components';

interface IKeyProps {
  type: 'income' | 'outgoing';
}

export const Container = styled.div<IKeyProps>`
  background: ${props => (props.type === 'income' ? '#ffffff' : '#e6f3ec')};
  border: 1px solid
    ${props => (props.type === 'income' ? '#eef2f7' : '#cde8d8')};
  border-radius: ${props =>
    props.type === 'income' ? '14px 14px 14px 4px' : '14px 14px 4px 14px'};
  max-width: 70%;
  width: fit-content;
  margin-bottom: 10px;
  padding: 10px 14px 8px;
  position: relative;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  align-self: ${props => (props.type === 'income' ? 'flex-start' : 'flex-end')};
  font-family: 'Plus Jakarta Sans', sans-serif;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
  }

  .timestamp {
    font-weight: 500;
    font-size: 10.5px;
    text-align: right;
    margin-top: 6px;
    color: ${props => (props.type === 'income' ? '#94a3b8' : '#4b8a64')};
    letter-spacing: 0.1px;
  }
`;

export const TextWrapper = styled.span`
  font-size: 14px;
  line-height: 1.5;
  color: #0f172a;
  word-break: break-word;
  white-space: pre-wrap;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0;

  img {
    max-width: 280px;
    max-height: 200px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
    object-fit: cover;
  }
`;

export const AudioWrapper = styled.div`
  width: 100%;
  min-width: 260px;
  margin: 4px 0;
  display: flex;
  align-items: center;
  background: rgba(15, 23, 42, 0.04);
  border-radius: 10px;
  padding: 8px 12px;
`;

export const DocumentWrapper = styled.a`
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  color: #0f172a;
  margin: 4px 0;
  transition: background 0.15s ease;
  font-weight: 500;
  font-size: 13px;

  &:hover {
    color: #006633;
    background: rgba(15, 23, 42, 0.08);
  }

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
